// Workflow landing page (`/`) — the screen the user lands on immediately after login. Renders inside
// AppLayout, so the sidebar is present in its `none` state (pill only, no nav list).
import { usePermissions } from '@/hooks/usePermissions';
import { useWorkflowSwitch } from '@/hooks/useWorkflowSwitch';
import LandingDecor from '@/features/workflow-landing/LandingDecor';
import WorkflowHero from '@/features/workflow-landing/WorkflowHero';
import WorkflowCardGrid from '@/features/workflow-landing/WorkflowCardGrid';
import '@/styles/pages/workflow-landing.css';

export default function WorkflowLandingPage() {
  const { can } = usePermissions();
  const switchWorkflow = useWorkflowSwitch();

  return (
    <>
      <LandingDecor />
      {/* z-index 1 (see workflow-landing.css) so the fixed decor paints behind the content rather
          than over it — .bg-object is a positioned z-index:0 element and would otherwise cover
          non-positioned text. */}
      <div className="workflow-landing">
        <WorkflowHero />

        {/* Eyebrow + cards are one flex child so leftover viewport height sits around this
            block, not between the label and the cards. */}
        <div className="wl-chooser">
          <p className="wl-eyebrow">
            <span className="wl-eyebrow-dot" aria-hidden="true" />
            Choose your workflow
          </p>

          <WorkflowCardGrid canPeDataset={can('pe:dataset')} onSelect={switchWorkflow} />
        </div>
      </div>
    </>
  );
}
